// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wyniger-home {
  --background: #fff;
}
.wyniger-home .main-container {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}
.wyniger-home .decoration-top-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 64px;
  height: 63px;
  opacity: 1; /* Figma shows full opacity, though assets might vary */
}
.wyniger-home .decoration-top-right ion-img {
  width: 100%;
  height: 100%;
}
.wyniger-home .logo-section {
  margin-top: 16vh;
  display: flex;
  justify-content: center;
  width: 100%;
}
.wyniger-home .logo-section .logo-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px; /* Increased gap to match design */
  width: auto;
}
.wyniger-home .logo-section .logo-wrapper .logo-icon {
  width: 280px;
  height: auto;
}
.wyniger-home .logo-section .logo-wrapper .logo-text {
  width: 274px; /* Matches viewbox width ratio approx */
  max-width: 80vw;
  height: auto;
}
.wyniger-home .center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 60px; /* Spacing between logo and title */
}
.wyniger-home .center-content .welcome-title {
  font-family: "Tinos", serif;
  font-weight: 700;
  font-size: 32px;
  color: white;
  margin-bottom: 40px;
  text-shadow: none; /* Ensure no inherited shadows */
  letter-spacing: 0.5px;
  text-align: center;
}
.wyniger-home .center-content .select-store-btn {
  --background: #0032C8;
  --border-radius: 300px;
  --color: white;
  --box-shadow: none;
  --padding-start: 40px;
  --padding-end: 40px;
  font-family: var(--font-family-sans);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  height: 44px;
  min-width: 272px;
}

.welcome {
  color: #0032C8;
  font-size: 32px;
  font-family: AppFontBlack;
  margin-top: 60px;
}
@media (height < 700px) {
  .welcome {
    margin-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.wyniger.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;AACC;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAEC;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA,EAAA,uDAAA;AAAF;AAEE;EACC,WAAA;EACA,YAAA;AAAH;AAIC;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAFF;AAKE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA,EAAA,kCAAA;EACA,WAAA;AAHH;AAKG;EACC,YAAA;EACA,YAAA;AAHJ;AAKG;EACC,YAAA,EAAA,uCAAA;EACA,eAAA;EACA,YAAA;AAHJ;AAQC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA,EAAA,mCAAA;AANF;AAQE;EACC,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA,EAAA,gCAAA;EACA,qBAAA;EACA,kBAAA;AANH;AASE;EACC,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EAEA,YAAA;EACA,gBAAA;AATH;;AAaA;EACC,cAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAVD;AAYC;EAND;IAOE,eAAA;EATA;AACF","sourcesContent":[".wyniger-home {\n\t--background: #fff;\n\n\t.main-container {\n\t\tposition: relative;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbackground-color: #fff;\n\t}\n\n\t.decoration-top-right {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\twidth: 64px;\n\t\theight: 63px;\n\t\topacity: 1; /* Figma shows full opacity, though assets might vary */\n\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\n\t.logo-section {\n\t\tmargin-top: 16vh;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\t// margin-bottom: 6rem;\n\n\t\t.logo-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tgap: 16px; /* Increased gap to match design */\n\t\t\twidth: auto;\n\n\t\t\t.logo-icon {\n\t\t\t\twidth: 280px;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t\t.logo-text {\n\t\t\t\twidth: 274px; /* Matches viewbox width ratio approx */\n\t\t\t\tmax-width: 80vw;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t}\n\t}\n\n\t.center-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-top: 60px; /* Spacing between logo and title */\n\n\t\t.welcome-title {\n\t\t\tfont-family: 'Tinos', serif;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 32px;\n\t\t\tcolor: white;\n\t\t\tmargin-bottom: 40px;\n\t\t\ttext-shadow: none; /* Ensure no inherited shadows */\n\t\t\tletter-spacing: 0.5px;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t.select-store-btn {\n\t\t\t--background: #0032C8;\n\t\t\t--border-radius: 300px;\n\t\t\t--color: white;\n\t\t\t--box-shadow: none;\n\t\t\t--padding-start: 40px;\n\t\t\t--padding-end: 40px;\n\n\t\t\tfont-family: var(--font-family-sans);\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 14px;\n\t\t\tletter-spacing: 0.56px;\n\t\t\ttext-transform: uppercase;\n\n\t\t\theight: 44px;\n\t\t\tmin-width: 272px;\n\t\t}\n\t}\n}\n.welcome {\n\tcolor: #0032C8;\n\tfont-size: 32px;\n\tfont-family: AppFontBlack;\n\tmargin-top: 60px;\n\n\t@media (height < 700px) {\n\t\tmargin-top: 00px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
